import { useEffect, useRef } from 'react';

interface UseOnScrollToTopOptions {
  ref: React.RefObject<HTMLElement> | null;
  onScrollToTop: () => void;
  threshold?: number; // distance from the top to consider "at the top"
  disabled?: boolean;
}

export function useOnScrollToTop({ ref, onScrollToTop, threshold = 0, disabled = false }: UseOnScrollToTopOptions) {
  const hasScrolledDown = useRef(false);
  const lastScrollTop = useRef(0);

  useEffect(() => {
    const container = ref?.current;

    if (!container || disabled) {
      return;
    }

    const handleScroll = () => {
      const scrollTop = container.scrollTop;

      if (scrollTop > lastScrollTop.current) {
        hasScrolledDown.current = true;
      }

      lastScrollTop.current = scrollTop;

      if (hasScrolledDown.current && scrollTop <= threshold) {
        onScrollToTop();

        hasScrolledDown.current = false;
      }
    };

    container.addEventListener('scroll', handleScroll, { passive: true });

    // eslint-disable-next-line consistent-return
    return () => {
      container.removeEventListener('scroll', handleScroll);
    };
  }, [onScrollToTop, threshold, disabled]);
}
